import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { Stack as c, Divider as u, Grid as r } from "@mui/material";
import { Button as l } from "./index26.mjs";
import { Typography as a } from "./index59.mjs";
import { messages as t } from "./messages2.mjs";
const x = (d) => {
  const { locale: i, onManageCookiesClick: m, onAcceptAllClick: p, onRejectAllClick: s } = d;
  return /* @__PURE__ */ o(c, { gap: 3, paddingY: 3, children: [
    /* @__PURE__ */ o(c, { gap: 3, paddingX: 3, children: [
      /* @__PURE__ */ e(a.H5, { color: (n) => n.palette.text.primary, children: t.title[i] }),
      /* @__PURE__ */ e(a.Body1, { color: (n) => n.palette.text.primary, children: t.description[i] })
    ] }),
    /* @__PURE__ */ e(u, {}),
    /* @__PURE__ */ o(r, { container: !0, spacing: 2, paddingX: 3, justifyContent: "flex-end", children: [
      /* @__PURE__ */ e(r, { xs: 6, item: !0, children: /* @__PURE__ */ e(
        l,
        {
          variant: "contained",
          size: "medium",
          fullWidth: !0,
          onClick: p,
          children: t.acceptAllButton[i]
        }
      ) }),
      /* @__PURE__ */ e(r, { xs: 6, item: !0, children: /* @__PURE__ */ e(
        l,
        {
          variant: "contained",
          size: "medium",
          fullWidth: !0,
          onClick: s,
          children: t.rejectAllButton[i]
        }
      ) }),
      /* @__PURE__ */ e(r, { xs: 12, sm: 12, item: !0, children: /* @__PURE__ */ e(
        l,
        {
          variant: "tertiary",
          size: "medium",
          color: "primary",
          fullWidth: !0,
          onClick: m,
          children: t.manageCookiesButton[i]
        }
      ) })
    ] })
  ] });
};
export {
  x as CookiesConsentMain
};
//# sourceMappingURL=index238.mjs.map
